import {EmojiFoodBeverage, Google} from "@mui/icons-material";
import {Avatar, Button, Dialog, IconButton, Stack, Tooltip, Typography} from "@mui/material";
import {useState} from "react";
import {red_900} from "./js/APXTheme.js";
import {getPlusAppLink, getPlusMessage} from "./plus/APXPlus.js";


// const generateURL = ({amount, name, upi}) => {
// 	  return `upi://pay?pa=${upi}&pn=${name}&am=${amount}&cu=INR`;
// };

// const url = generateURL({ amount, name, upi });
// const qrCode =  QRCode.toDataURL(url, {
//     type: "image/png",
//     margin: 1,
//     width: 300,
// });


const keepDisabled = false;
const imageUrl = "";

export default function APXBuyMeACupOfTea() {
	  const [showDialog, setShowDialog] = useState(false);
	  return (
				 <>
						<Tooltip title={"Buy me a cup of tea"}>
							  <IconButton disabled={keepDisabled} size={"large"} color={"primary"} onClick={() => setShowDialog(true)}><EmojiFoodBeverage/></IconButton>
						</Tooltip>
						<Dialog open={showDialog} onClose={() => setShowDialog(false)}>
							  <Stack alignItems={"center"} p={4} spacing={4} justifyContent={"center"}>
									 <Avatar sx={{backgroundColor: red_900, width: "60px", height: "60px"}}><EmojiFoodBeverage fontSize={"large"}/></Avatar>
									 {/* <Avatar variant={"square"} src={imageUrl} alt={"Coming Soon"} sx={{width: 180, height: "auto"}}/> */}
									 <Typography align={"center"} variant={"h6"}>{getPlusMessage(false)}</Typography>
									 <Button size={"large"} variant={"contained"} startIcon={<Google/>} sx={{opacity: 0.85}}
												onClick={() => {
													  window.open(
																 getPlusAppLink(),
																 "_blank",
																 "noopener,noreferrer"
													  );
												}}>
											Go to PlayStore
									 </Button>
							  </Stack>
						</Dialog>
				 </>
	  );
};